import React, { useState, useEffect, useContext } from "react";
import BannerSalon from "../../assets/showcases/salon-banner.jpg";
import BannerTrainer from "../../assets/showcases/trainer-banner.png";
import BannerBarber from "../../assets/showcases/barber-banner.png";
import { Avatar, Box, Button, Typography, Grid, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ArrowForwardIosOutlined } from "@mui/icons-material";
import { CreatorContext } from "../../context/CreatorContext";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";

import ProductCategories1 from "../../assets/showcases/ecommerce/categories1.jpg";
import ProductCategories2 from "../../assets/showcases/ecommerce/categories2.jpg";
import ProductCategories3 from "../../assets/showcases/ecommerce/categories3.jpg";
import ProductCategories4 from "../../assets/showcases/ecommerce/categories4.jpg";
import ProductCategories5 from "../../assets/showcases/ecommerce/categories5.jpg";
import ProductCategories6 from "../../assets/showcases/ecommerce/categories6.jpg";
import { SearchOutline } from "react-ionicons";

const ShowcaseSearch = ({
	sector,
	search,
	showPadding,
	backgroundColor1 = "#ebebeb",
	backgroundColor2 = "#ebebeb",
}) => {
	const { t } = useTranslation();
	const [content, setContent] = useState(null);
	const { creator } = useContext(CreatorContext);

	console.log(search?.value);

	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "ecommerce":
					return {
						categories: [
							{
								name: t("homeCategories.sweaters"),
								image: ProductCategories1,
							},
							{
								name: t("homeCategories.shirts"),
								image: ProductCategories2,
							},
							{
								name: t("homeCategories.handbags"),
								image: ProductCategories3,
							},
							{
								name: t("homeCategories.skirts"),
								image: ProductCategories4,
							},
							{
								name: t("homeCategories.blazers"),
								image: ProductCategories5,
							},
							{
								name: t("homeCategories.jeans"),
								image: ProductCategories6,
							},
						],
					};

				case "restaurant":
					return {
						categories: [
							{
								name: t("menuCategories.classicPizzas"),
								image: ProductRestaurant1,
							},
							{
								name: t("menuCategories.gourmetPizzas"),
								image: ProductRestaurant2,
							},
							{
								name: t("menuCategories.specialPizzas"),
								image: ProductRestaurant5,
							},
							{
								name: t("menuCategories.others"),
								image: ProductRestaurant2,
							},
						],
					};

				default:
					return {};
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	return (
		<Box
			sx={{
				position: "relative",
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			<Box
				sx={{
					padding: "6px",
					backgroundColor: creator.searchContainerBackgroundColor,
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						padding: "0px 6px",
						height: "18px",
						borderRadius: "4px",
						backgroundColor: creator.searchBackgroundColor,
						color: creator.searchTextColor,
						width: "100%",
					}}
				>
					{creator.showSearchIcon && (
						<SearchOutline
							color={creator.searchTextColor}
							style={{
								height: "auto",
								marginRight: "8px",
								opacity: 0.6,
							}}
							width="10px"
						/>
					)}
					<Typography variant="body2" sx={{ fontSize: "8px", opacity: 0.9 }}>
						{t("search.search")}
					</Typography>
				</Box>
			</Box>

			{content && search?.value === "search4" && (
				<Box sx={{ padding: 0 }}>
					{content.categories.map((cat, index) => (
						<Box
							key={index}
							sx={{
								position: "relative",
								overflow: "hidden",
								display: "flex",
								marginBottom: 0,
							}}
						>
							<img
								src={cat.image}
								alt={cat.name}
								style={{
									width: "100%",
									height: "70px",
									objectFit: "cover",
								}}
							/>
							<Box
								sx={{
									position: "absolute",
									fontWeight: "bold",
									top: "40%",
									textAlign: "center",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									paddingLeft: 1,
									paddingRight: 1,
									width: "100%",
								}}
							>
								<Typography
									variant="h6"
									sx={{
										textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
										textTransform: "inherit",
										fontSize: "8px",
										color: "#FFFFFF",
									}}
								>
									{cat.name}
								</Typography>
								<ArrowForwardIosOutlined
									sx={{
										fontSize: 8,
										color: "#ffffff",
										textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
									}}
								/>
							</Box>
						</Box>
					))}
				</Box>
			)}

			{content && search?.value === "search5" && (
				<Box sx={{ padding: 0 }}>
					{content.categories.map((cat, index) => (
						<Box
							key={index}
							sx={{
								position: "relative",
								overflow: "hidden",
								display: "flex",
								marginBottom: 0,
							}}
						>
							<img
								src={cat.image}
								alt={cat.name}
								style={{
									width: "100%",
									height: "120px",
									objectFit: "cover",
								}}
							/>
							<Box
								sx={{
									position: "absolute",
									fontWeight: "bold",
									top: "40%",
									textAlign: "center",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									paddingLeft: 1,
									paddingRight: 1,
									width: "100%",
								}}
							>
								<Typography
									variant="h6"
									sx={{
										textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
										textTransform: "inherit",
										fontSize: "8px",
										color: "#FFFFFF",
									}}
								>
									{cat.name}
								</Typography>
								<ArrowForwardIosOutlined
									sx={{
										fontSize: 8,
										color: "#ffffff",
										textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
									}}
								/>
							</Box>
						</Box>
					))}
				</Box>
			)}

			{content && search?.value === "search3" && (
				<Box sx={{ padding: 1 }}>
					{content.categories.map((cat, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								borderBottom: "1px solid #e0e0e0",
								paddingTop: 1.5,
								paddingBottom: 1.5,
							}}
						>
							<Typography
								variant="body1"
								sx={{
									fontSize: "9px",
								}}
							>
								{cat.name}
							</Typography>
							<ArrowForwardIosOutlined sx={{ fontSize: "8px" }} />
						</Box>
					))}
				</Box>
			)}
			{content && search?.value === "search2" && (
				<Box sx={{ padding: 1 }}>
					{content.categories.map((cat, index) => (
						<>
							<Box
								key={index}
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
									<img
										src={cat.image}
										alt={cat.name}
										style={{
											width: "40px",
											height: "40px",
											borderRadius: "20px",
											objectFit: "cover",
										}}
									/>
									<Typography
										variant="body1"
										sx={{
											fontSize: "9px",
											textAlign: "left",
										}}
									>
										{cat.name}
									</Typography>
								</Box>
								<ArrowForwardIosOutlined sx={{ fontSize: "8px" }} />
							</Box>
							<Divider sx={{ marginBottom: 1.5, marginTop: 1.5 }}></Divider>
						</>
					))}
				</Box>
			)}

			{content && search?.value === "search1" && (
				<Box sx={{ padding: 1 }}>
					{content.categories.map((cat, index) => (
						<>
							<Box
								key={index}
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
									<img
										src={cat.image}
										alt={cat.name}
										style={{
											width: "40px",
											height: "40px",
											objectFit: "cover",
										}}
									/>
									<Typography
										variant="body1"
										sx={{
											fontSize: "9px",
											textAlign: "left",
										}}
									>
										{cat.name}
									</Typography>
								</Box>
								<ArrowForwardIosOutlined sx={{ fontSize: "8px" }} />
							</Box>
							<Divider sx={{ marginBottom: 1.5, marginTop: 1.5 }}></Divider>
						</>
					))}
				</Box>
			)}

			{content && search?.value === "search6" && (
				<Box sx={{ padding: 0 }}>
					{content.categories.map((cat, index) => (
						<Box
							key={index}
							sx={{
								position: "relative",
								overflow: "hidden",
								height: "100px",
							}}
						>
							<img
								src={cat.image}
								alt={cat.name}
								style={{
									width: "100%",
									height: "100px",
									objectFit: "cover",
									filter: "brightness(60%)",
								}}
							/>
							<Typography
								variant="h6"
								sx={{
									position: "absolute",
									top: "50%",
									left: "50%",
									transform: "translate(-50%, -50%)",
									color: "#ffffff",
									fontSize: "8px",
									textTransform: "inherit",
								}}
							>
								{cat.name}
							</Typography>
						</Box>
					))}
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseSearch;
